<span *ngIf="loading">Loading...</span>
<span *ngIf="!src && loading==false">Failed to load preview</span>

<iframe
	*ngIf="src"
	style="width: 100%; height: 100%; border: none;"
	[src]="src">
</iframe>
